import React from 'react';
import axios from 'axios';
import Promise from 'bluebird';


import component, {classnames} from './component';
import Dropzone from './Dropzone';
import Api from '../api';
import Flag from './Flag';
import EditField from './EditField';
import {Skype} from './icons';
import DataEditButton from './DataEditButton';

import {Warning} from './icons';

import _ from 'lodash';
import teamRoles from './teamRoles';

import League from './League';

import notices from './notices';


export default component('Avatar', function({data, type, isOwner, popup, isNew, customClass, league, leagueClassName}) {

  const params = {
    User: {
      key: 'nickname',
      methodUpdate: 'userUpdate',
      uploadUrl: '/api/profile/image/upload/'
    },
    Team: {
      key: 'title',
      methodUpdate: 'teamUpdate',
      uploadUrl: '/api/captain/image/upload/'
    },
    TeamNew: {
      key: 'title',
      uploadUrl: '/api/captain/image/upload/'
    }
  };

  async function uploadLogo(file) {
    const payload = new FormData();
    payload.append('image', file);
    data.setIn('imageUploading', true);
    const response = await axios.post(params[type].uploadUrl, payload, {
      transformRequest: (data) => data
    });
    data.update(x => x.set('image', response.data.image).set('imageUploading', false));
  }

  async function deleteLogo(e) {
    e.preventDefault();
    e.stopPropagation();
    uploadLogo(null);
  }

  function onDrop(files) {
    for (let file of files) {
      if (/image/.test(file.type)) {
        return uploadLogo(file);
        break;
      }
    }
  }

  function NameError(){
    popup.set({
      icon: Warning,
      message: notices.incorrectNickName,
      action: 'Ok',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    });
  }

  const url = data.get('image');

  const Component = (!isOwner || data.get('imageUploading')) ? 'div' : Dropzone;

  const style = {};

  if (url) {
    style.backgroundImage = `url(${url}?crop=1&w=224&h=224)`;
  } else {
    style.backgroundImage = `url(${require('../img/teamEmptyAvatarSquare.png')})`;
  }

  const avatarCls = {
    'Avatar': true,
    [`Avatar--${type}`]: true,
    [`Avatar--${customClass}`]: !!customClass
  };

  async function updateContact() {
    let response = await Api[params[type].methodUpdate]({
      id: data.get('id'),
      contact: data.get('contact')
    });
    data.set(response.data);
  }

  // TODO: handle 409
  async function updateName() {
    try {
      const response = await Api[params[type].methodUpdate]({
        id: data.get('id'),
        [params[type].key]: data.get(params[type].key)
      });

      data.set(response.data);
    } catch(error) {
      NameError()
      return true;
    }
  }

  const fakeClick = () => {};

  const teamContact = (() => {
    if(type === 'Team' && data.get('members')){
      let members = data.get('members').toJS();
      let captain = _.find(members, {role: teamRoles['captain'].id});
      return captain && captain.user.contact || null;
    }
    return null;
  })();

  return (
    <div className={classnames(avatarCls)}>
      <League className={leagueClassName} league={league} withText/>
      <div className="AvatarContainer">
        <Component className={classnames('AvatarImage', (!url || isNew) && 'AvatarImage--Stubbed',
            data.get('imageUploading') && 'AvatarImage--Uploading',
            (!isOwner || (isOwner && isNew)) && 'AvatarImage--NotOwner')}
                   onDrop={onDrop}
                   style={style}>
          {isOwner && !isNew &&
            <div className='AvatarImage-Actions'>
              {isOwner && (type === 'Team' || type === 'User') &&
              <div className='AvatarImage-ButtonContainer'>
                <DataEditButton text={url ? 'Изменить лого' : 'Добавить лого'} onClick={fakeClick}/>
                {url &&
                  <DataEditButton text='Удалить лого' onClick={deleteLogo} />
                }
              </div>
              }
            </div>
          }
        </Component>
      </div>
      <h1 className='Avatar-OwnerName'>
        {
          isOwner && ((type === 'User') || (type === 'TeamNew'))
            ?
            <EditField
              icon={data.hasData('country') && <Flag country={data.get('country')} />}
              updateMethod={type === 'User' && updateName}
              valueKey={params[type].key}
              data={data}
              defaultValue="Добавить имя"
            />
            :
            <div className="Avatar-OwnerName--Wrap">
              <span className="Avatar-Icon">
                {data.hasData('country') && <Flag country={data.get('country')} />}
              </span>
              <span className="Avatar-OwnerNameTitle">
                {data.get(params[type].key)}
              </span>
            </div>
        }

      </h1>
      <div className='Avatar-Skype'>
      {type === 'User' &&
        <div>
          {isOwner ?
            <EditField
              icon={<Skype />}
              updateMethod={updateContact}
              valueKey='contact'
              data={data}
              defaultValue="Добавить skype"
            />
            :
            <div>
              {
                data.get('contact') &&
                <div className="Avatar-OwnerName--Wrap">
                  <span className="Avatar-SkypeIcon">
                    <Skype />
                  </span>
                  <span className="Avatar-CaptionTitle">
                    {data.get('contact')}
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
      {teamContact &&
            <div className="Avatar-OwnerName--Wrap">
                  <span className="Avatar-SkypeIcon">
                    <Skype />
                  </span>
                  <span className="Avatar-CaptionTitle">
                    {teamContact}
                  </span>
            </div>
       }
      </div>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/Avatar.js